import { render, staticRenderFns } from "./GridTable.vue?vue&type=template&id=1401feb0&scoped=true&"
import script from "./GridTable.vue?vue&type=script&lang=js&"
export * from "./GridTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401feb0",
  null
  
)

export default component.exports